import { Avatar, Grid2, Stack, Typography } from '@mui/material';

function getColorFromHash(string) {
    let hash = 0;
    let i;
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#'; 
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
    return color;
}
  

export function ContactCell({...params}){

    let row = params.row
    let channelID = ''
    let contacts = ''
    let page = ''
    let contactsAlignment = ''
     if (row === undefined) {
        if(params.affiliate === undefined) {
            channelID = params.callSign.toLowerCase()
        } else {
            channelID = params.callSign.toLowerCase() + "-" + params.affiliate.toLowerCase()
        }
        contacts = params.contacts
        contactsAlignment = 'flex-end'
        page = 'ChannelPage'
    }
    else {
        channelID = params.id
        contacts = params.row.station_contacts
        contactsAlignment = 'flex-start'
        page = 'StationsPage'
    }


    function coloredAvatar(name) {
        return {
          sx: { bgcolor: getColorFromHash(name), width: '3rem', height: '3rem',},
          children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
        };
    }

    let titleBottomMargin = '5%'
    if (contacts === undefined) titleBottomMargin = '1%'

    return ( 
        <>

            {(page === 'ChannelPage') && (
                <Grid2 display={'flex'} justifyContent={'center'}  paddingTop={'2%'} marginBottom={titleBottomMargin} id={'ContactCellTitleGrid'}>
                    <Typography sx={{borderColor: 'primary.main'}} borderBottom={'1px solid'}>
                        Station Contacts
                    </Typography>
                </Grid2>
            )}


            <Grid2 id={'AllContactsGrid'}>

                {(contacts === undefined && page === 'ChannelPage') && (
                    <Grid2 display={'flex'} justifyContent={'center'} paddingTop={'1%'} marginBottom={'2%'} id={'NoContactsFoundGrid'}>
                        <Typography padding={'1%'}>
                            <a href={'/editpage/' + channelID}>Add your contacts using the Edit Portal!</a>
                        </Typography>
                    </Grid2>

                )} 
                {(contacts !== undefined) && (
                    contacts.map((contact) => (
                        <Stack direction={'row'} paddingBottom={'5%'} width={'100%'} justifyContent={'space-between'} id={'ContactRowStack'}>
                            {(page === 'ChannelPage') && (
                                <Grid2 direction={'column'} alignItems={'flex-start'} id={'AvatarGrid'}>
                                    <Avatar {...coloredAvatar(contact.name)} />
                                </Grid2>
                            )}
    
                            <Stack direction={'column'} alignItems={contactsAlignment} id={'NameAndEmailStack'}>
                                <Typography >{contact.name}</Typography>
                                <Typography>{contact.email}</Typography>
                            </Stack>  
                        </Stack>
                    ))
                )}
            </Grid2>
        </>
    )
}

//(valueToGiveToFilterrer = Aaron Anderson,Aaronanderson@sbgtv.com,Bob Balfour,bobman23@sbgtv.com,...)
export const ContactCellFilter = (contacts) => {

    if (contacts !== undefined){
    
        let valueToGiveToFilterer = []
        for (let i = 0; i < contacts.length; i++){
            let contact = contacts[i]
            valueToGiveToFilterer.push(contact.name)
            valueToGiveToFilterer.push(contact.email)
        }

        valueToGiveToFilterer = String(valueToGiveToFilterer)
        return valueToGiveToFilterer
    }

    else return ''
}
